import { useQuery } from '@apollo/client';
import { useParams } from 'react-router';

import { UpdateCompanySignupStatusMutation } from './update_company_signup_status_container';
import { CompanyOnboardingQuery, CompanyOnboardingQueryVariables } from '../../lib/graphql';
import { Loader } from '../../lib/loader';
import { CompanyOnboardingView, OnboardingViewProps } from '../components/company_onboarding/company_onboarding';
import { companyOnboardingQuery } from '../graphql';

class LoadingContainer extends Loader<CompanyOnboardingQuery, OnboardingViewProps, CompanyOnboardingQueryVariables> {}

export const CompanyOnboardingContainer = () => {
  const { company_id } = useParams() as { company_id: string };
  const result = useQuery<CompanyOnboardingQuery, CompanyOnboardingQueryVariables>(companyOnboardingQuery, {
    variables: {
      company_id,
    },
  });

  return (
    <UpdateCompanySignupStatusMutation>
      {({ updateCompanySignupStatus }) => (
        <LoadingContainer
          result={result}
          mapData={({ data }) => ({
            data: { company: data.company ?? null, __typename: 'Query' },
            updateSignupStatus: updateCompanySignupStatus,
          })}>
          {(props) => <CompanyOnboardingView {...props} />}
        </LoadingContainer>
      )}
    </UpdateCompanySignupStatusMutation>
  );
};
